import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const JobListRoute: RouteType = {
  name: "Job Management",
  path: "/estimating/jobs",
  layout: "/app",
  group: "Estimating",
  requiresAuth: true,
  requiresPermission: false,
  defaultQueryParams: { search: "", status: "all", view: "jobs" },
  viewportCard: {
    header: {
      title: "Job Management",
      component: () => import("./JobListHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./JobListBody"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore, queryParams }) => {
    try {
      const JobListViewStore = (await import("./JobListViewStore")).default;

      if (!(rootStore as any).jobListViewStore) {
        (rootStore as any).jobListViewStore = new JobListViewStore(rootStore);
      }

      const promises = [];

      const manholeProjectsStore =
        rootStore.manholeProjectsStore as ServiceStore;
      if (manholeProjectsStore) {
        promises.push(manholeProjectsStore.find());
      }

      const manholeStructuresStore =
        rootStore.manholeStructuresStore as ServiceStore;
      if (manholeStructuresStore) {
        promises.push(manholeStructuresStore.find());
      }

      const manholeQuotesStore =
        rootStore.manholeQuotesStore as ServiceStore;
      if (manholeQuotesStore) {
        promises.push(manholeQuotesStore.find());
      }

      const customersStore = rootStore.customersStore as ServiceStore;
      if (customersStore) {
        promises.push(customersStore.find());
      }

      await Promise.allSettled(promises);

      // Role-based default view: estimators see quotes by default
      const viewStore = (rootStore as any).jobListViewStore;
      if (!queryParams?.view || queryParams.view === "jobs") {
        const user = (rootStore as any).authStore?.currentUser;
        const dept = (user?.department || "").toLowerCase();
        const team = (user?.team || "").toLowerCase();
        if (dept.includes("estimat") || team.includes("estimat")) {
          (rootStore as any).routerStore.goTo(null, null, {
            ...(rootStore as any).routerStore.queryParams,
            view: "quotes",
          });
        }
      }

      // Restore search/filter from query params
      if (queryParams?.search) {
        viewStore.setSearchQuery(queryParams.search as string);
      }
      if (queryParams?.status) {
        viewStore.setStatusFilter(queryParams.status as string);
      }

      return true;
    } catch (error) {
      console.error("Failed to load job management data:", error);
      return true;
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).jobListViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default JobListRoute;
